var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<map-coordinates country-code=\"routePlan.countryCode\" city=\"city\" address=\"address\" on-save=\"setCoordinates\"></map-coordinates>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/editCoordinates.jade
 ** module id = 77
 ** module chunks = 1
 **/